import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import '@fontsource/geist-sans/300.css';
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/700.css';
import '@/styles/globals.css';
import '@/i18n/i18n';
import '@/features/table/consts/agGridModules';

import { Providers } from '@/providers/Providers';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers />
  </StrictMode>
);
